import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitContact = async (data) => {
  const res = await axios.post(`${API}/contact`, data);
  return res.data;
};

export const submitQuote = async (data, files) => {
  const formData = new FormData();
  formData.append('payload', JSON.stringify(data));
  (files || []).forEach((file) => formData.append('files', file));
  const res = await axios.post(`${API}/quote`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};
